import { Component, ElementRef, Renderer2 } from '@angular/core';
import { HeroComponent } from '../../shared/hero/hero.component';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedService } from '../../../services/shared/shared.service';
import { FirestoreService } from '../../../services/firestore/firestore.service';
import { AuthServiceService } from '../../../services/authService/auth-service.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-job-details',
  imports: [HeroComponent,CommonModule],
  templateUrl: './job-details.component.html',
  styleUrl: './job-details.component.css'
})
export class JobDetailsComponent {
  jobDetails:any;
  id:any;
  isLoggedIn=false;
  constructor(private router:ActivatedRoute,
    private firstoreService:FirestoreService,
    private renderer:Renderer2,
    private el:ElementRef,
    private route:Router,
    private authService:AuthServiceService
  ) { }
  ngOnInit() {
    this.id = this.router.snapshot.params['id'];
    this.firstoreService.getById("jobs",this.id).subscribe({
      next:res=>this.jobDetails=res
    })
    setTimeout(() => {
      this.activeFaqItem();
    }, 500);

    this.isUserLoggedIn();
  }


  activeFaqItem() {
    const faqItems = this.el.nativeElement.querySelectorAll('.faq-item');
  
  
    faqItems.forEach((faqItem: HTMLElement) => {
      this.renderer.listen(faqItem, 'click', (event) => {
  
        faqItems.forEach((item: HTMLElement) => {
          this.renderer.removeClass(item, 'faq-active');
        });
  
        this.renderer.addClass(faqItem, 'faq-active');
  
        const content = faqItem.querySelector('.faq-content') as HTMLElement;
        if (content) {
          const isActive = faqItem.classList.contains('faq-active');
          this.renderer.setStyle(content, 'display', isActive ? 'block' : 'none');
        }
      });
    });
  }
  
    isUserLoggedIn(){
      this.authService.isUserLoggedIn().subscribe({
        next:res=>{ this.isLoggedIn=res},
      })
    }
  
  
    navigateToApplicationComponent(jobId: string) {
      if (this.isLoggedIn) {
        this.route.navigateByUrl("/application/" + jobId);
      } else {
        Swal.fire({
  icon: 'warning',
  title: 'Nicht angemeldet',
  text: 'Sie müssen sich zuerst anmelden, um sich für diesen Job zu bewerben.',
  confirmButtonText: 'OK'
});
      }
  

}


}
